import type { AxiosResponse } from 'axios';
import type { ThunkAction } from 'redux-thunk';

import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import store from 'store';
import { NotificationsAction, showError } from '@spike/notifications-action';

import {
    TAX_LIST_DETAIL_REPORT_GET_ERROR,
    TAX_LIST_DETAIL_REPORT_GET_START,
    TAX_LIST_DETAIL_REPORT_GET_SUCCESS,
    TaxListDetailReportAction
} from './TaxListDetailReportActionsTypes';

import type { TaxListDetailReportDto } from './TaxListDetailReportDto';
import { convertToTaxListDetailReport } from './taxListDetailReportConverter';
import type { TaxListDetailReport } from 'model/TaxListReport';

export const getTaxListDetailReport = (
    start?: string,
    end?: string,
    page?: number,
    size?: number
): ThunkAction<void, null, null, TaxListDetailReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId, token } = store.getState().login.auth;

        let url = `/tax_list_report?marketplace_id=${marketplaceId}`;
        if (start) url += `&start=${start}`;
        if (end) url += `&end=${end}`;
        if (page) url += `&page=${page}`;
        if (size) url += `&size=${size}`;

        try {
            const response: AxiosResponse<TaxListDetailReportDto | { data: TaxListDetailReportDto }> =
                await ApiClient.get(url, createTokenConfig(token!));
            const payload = response.data && 'data' in response.data ? response.data.data : response.data;
            dispatch(getSuccess(convertToTaxListDetailReport(payload as TaxListDetailReportDto)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Unable to load tax list. Please try again or use a shorter date range.'));
            }
        }
    };
};

const getStart = (): TaxListDetailReportAction => ({
    type: TAX_LIST_DETAIL_REPORT_GET_START
});

const getSuccess = (report: TaxListDetailReport): TaxListDetailReportAction => ({
    type: TAX_LIST_DETAIL_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): TaxListDetailReportAction => ({
    type: TAX_LIST_DETAIL_REPORT_GET_ERROR
});
